<template>
  <section v-bind:class="selector">
    <transition-group name="fade" class="img-container">
      <div class="img-container-inner" v-for="(photo, index) in photoUri" :key="`photo-${index}`">
        <img :src="photo" />
      </div>
    </transition-group>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { useMainStore } from "@/store";
import Album from "@/models/Albums";

export default defineComponent({
  name: "DisplayPhoto",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  setup(props) {
    const store = useMainStore();
    const index = ref(0);
    const ScrollStatus = ref(0);
    const ScrollMax = ref(0);

    const albumId = computed(() => typeof props.id === 'string' ? parseInt(props.id) : props.id);

    const host = computed(() => {
      return process.env.VUE_APP_API_URL + "/static/images/";
    });

    onMounted(() => {
      store.fetchAlbums(albumId.value);
    });

    const photos = computed(() => {
      const albums: Album[] = store.albums;
      return albums.find((e: Album) => e.id === albumId.value)?.photos;
    });

    const photoUri = computed(() => {
      return photos.value?.map((photo) => host.value + photo.filename);
    });

    const randomIndex = () => {
      if (photos.value) {
        return Math.floor(Math.random() * photos.value.length);
      }
    };

    const selector = computed(() => {
      if (ScrollStatus.value > 0) {
        return ScrollStatus.value + 30 >= ScrollMax.value
          ? "main-wrapper-end"
          : "main-wrapper-middle";
      }
      return "main-wrapper-start";
    });

    const scrolling = (ev: any) => {
      const post = ev.target;
      ScrollStatus.value = post.scrollLeft;
      ScrollMax.value = post.scrollWidth - post.clientWidth;
    };

    return {
      index,
      ScrollStatus,
      ScrollMax,
      host,
      photos,
      photoUri,
      randomIndex,
      selector,
      scrolling,
    };
  },
});
</script>

<style scoped lang="scss">
@media only screen and (min-width: 769px) {
  .main-wrapper {
    height: 100vh;
    width: 100%;

    &-start {
      //padding-left: 1rem;
    }
    &-middle {
      //padding: 0px;
    }
    &-end {
      //padding-right: 1rem;
    }
  }

  .img-container {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    height: 80vh;
    width: auto;
    scroll-snap-type: x mandatory;
  }

  img {
    height: 60vh;
    width: auto;
    padding: 0% 1vh;
    object-fit: contain;
    scroll-snap-align: center;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}

@media only screen and (max-width: 768px) {
  .main-wrapper {
    height: 100vh;
    width: 100%;

    &-start {
      //padding-left: 1rem;
    }
    &-middle {
      //padding: 0px;
    }
    &-end {
      //padding-right: 1rem;
    }
  }

  .img-container {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    flex-direction: column;
    height: auto;
    width: 100%;
  }

  img {
    height: auto;
    width: 100%;
    justify-items: center;
    object-fit: contain;
    scroll-snap-align: center;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
